'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chapter = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _List = require('material-ui/List');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isVideoOfChapter(props) {
  var contents = props.contents,
      curVideoId = props.curVideoId;


  return contents.some(function (x) {
    return x.videoId === curVideoId;
  });
}

var Chapter = _react2['default'].createClass({

  displayName: "Chapter",

  mixins: [_reactAddonsPureRenderMixin2['default']],

  getInitialState: function getInitialState() {

    return {
      open: isVideoOfChapter(this.props)
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {

    if (nextProps.curVideoId !== this.props.curVideoId && isVideoOfChapter(nextProps)) {

      // Ein neues Video wurde begonnen, welches zur Gruppe gehört. Also die
      // Gruppe automatisch öffnen, damit alle enthaltenen Titel sichtbar
      // sind (und die Markierung).
      this.setState({ open: true });
    }
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        title = _props.title,
        children = _props.children;
    var open = this.state.open;


    return _react2['default'].createElement(_List.ListItem, {
      open: open,
      initiallyOpen: true,
      primaryText: title,
      nestedItems: children,
      primaryTogglesNestedList: true,
      onNestedListToggle: function onNestedListToggle() {
        return _this.setState({ open: !open });
      }
    });
  }
});

exports.Chapter = Chapter = (0, _reactRedux.connect)(function (state) {

  var curVideoId = undefined;

  try {

    var route = state.router.location.pathname;

    if (route.startsWith("/v/")) curVideoId = decodeURIComponent(route.split("/")[2]);
  } catch (e) {

    console.error(e);
    // ignore
  }

  return { curVideoId: curVideoId };
})(Chapter);

exports.Chapter = Chapter;


//////////////////
// WEBPACK FOOTER
// ./program/frontend/sidebar/chapter.jsx
// module id = 968
// module chunks = 0